import Favourite from '../../components/Favourite'

export const FavouritePage =()=><Favourite/>

export default FavouritePage